import { DOCUMENT } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    HostListener,
    inject,
    PLATFORM_ID,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { DealerFeature, UiFeature } from '@hyundai/ng-common-lib';
import { M040C005ImprintNoticeComponent, M040C150HighlightBannerComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';
import { getHighlightBannerData } from '../../utils/extra-router-selectors';
import { FooterPwComponent } from '../footer-pw/footer-pw.component';
import { NavBarComponent } from '../nav/nav-bar/nav-bar.component';
import { NavWrapperComponent } from '../nav/nav-wrapper.component';

@Component({
    selector: 'app-partner-web',
    standalone: true,
    imports: [
        RouterOutlet,
        FooterPwComponent,
        NavBarComponent,
        M040C005ImprintNoticeComponent,
        M040C005ImprintNoticeComponent,
        NavWrapperComponent,
        M040C150HighlightBannerComponent,
    ],
    templateUrl: './partner-web.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerWebComponent {
    store = inject(Store);
    platformId = inject(PLATFORM_ID);
    renderer = inject(Renderer2);
    document = inject(DOCUMENT);
    route = inject(ActivatedRoute);

    showImprintNotice = this.store.selectSignal(DealerFeature.state.selectShowImprintNotice);

    showMenu = this.store.selectSignal(UiFeature.state.selectShowMenu);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    richDealerData = this.store.selectSignal(DealerFeature.state.selectRichDealerData);
    socialLinks = this.store.selectSignal(DealerFeature.state.selectSocialLinks);

    highlightBannerRouteData = getHighlightBannerData();

    showHighlightBanner = computed(() => {
        const routeData = this.highlightBannerRouteData();
        const { highlightBanner } = this.dealer();
        const routeDataHighlightBanner = routeData?.highlightBanner;

        if (!highlightBanner || !routeDataHighlightBanner) {
            return false;
        }

        return highlightBanner.globalCampaign
            ? Boolean(routeDataHighlightBanner.showGlobalBanner)
            : Boolean(routeDataHighlightBanner.showDealerBanner);
    });

    @HostListener('click', ['$event.target'])
    handleFootnoteClick(target: EventTarget | null) {
        if (!(target instanceof HTMLElement) || target.tagName !== 'SUP') {
            return;
        }

        const id = target.getAttribute('class')?.match(/(^|\s)f_(\w+)(\s|$)/)?.[2];
        if (!id) {
            return;
        }

        document.querySelector(`#${id}`)?.scrollIntoView({ behavior: 'smooth' });
    }

    setRichDealerDataEffect = effect(() => {
        const richDealerData = this.richDealerData();

        const script = this.renderer.createElement('script') satisfies HTMLScriptElement;
        script.type = 'application/ld+json';
        script.text = JSON.stringify(richDealerData);

        this.renderer.appendChild(this.document.body, script);
    });
}
